import { createSlice } from '@reduxjs/toolkit';

export type ProfileMuseumArtworksDisplayState = {
  isFiltersDialogOpen: boolean;
};

export const getDefaultDisplay = (): ProfileMuseumArtworksDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: ProfileMuseumArtworksDisplayState = getDefaultDisplay();

export const displayProfileMuseumArtworksSlice = createSlice({
  name: 'display',
  initialState: displayInitialState,
  reducers: {
    OPEN_FILTERS_ProfileMuseumArtworks: (state) => {
      state.isFiltersDialogOpen = true;
    },
    CLOSE_FILTERS_ProfileMuseumArtworks: (state) => {
      state.isFiltersDialogOpen = false;
    },
  },
});
